function _(n,t,i){var o=n(74),r=n(30);t.exports=function(n){return r(n)?n:o(n,"%v is not a plain function",arguments[1])}}
//# sourceMappingURL=ensure.min.js.map